// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3-lIw","label":"CategoryService_label__2ZMPg","location":"CategoryService_location__2H8Lu"};